import {useEffect} from 'react'
import {SliderEditModalHeader} from './SliderEditModalHeader'
import {SliderEditModalFormWrapper} from './SliderEditModalFormWrapper'
import { ID } from '../../../../../_dashboard/helpers'
type Props = {
  sectionId: ID // Ajouter cette ligne
  pageId: ID    // Ajouter cette ligne
  onClose: () => void
}
const SliderEditModal = ({ sectionId, pageId, onClose }: Props) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className={`modal fade ${sectionId ? 'show d-block' : 'd-none'}`} 
        id='kt_modal_add_section'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-350'>
        {/* begin::Modal content */}
          <div className='modal-content'>
          <SliderEditModalHeader onClose={onClose} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-5 my-1'>
            <SliderEditModalFormWrapper pageId={pageId} sectionId={sectionId} onSuccess={onClose} // Fermer après soumission
            onClose={onClose} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {SliderEditModal}
